import React, { useState } from "react";
import home from "../../assets/img/home.png";
import { Link, useNavigate } from "react-router-dom";

function CompanyMap() {
  const [selectedTab, setSelectedTab] = useState("company"); // Default tab
  const navigate = useNavigate();

  // 함수를 통해 선택된 탭을 변경하는 로직
  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    navigate(`/${tab}`);
  };

  // 함수를 통해 선택된 탭에 따라 타이틀을 동적으로 생성
  const renderTitle = () => {
    switch (selectedTab) {
      case "company":
        return <p>코끼리협동조합</p>;
      // case "company2":
      //   return <p>팀 소개</p>;
      case "company3":
        return <p>연혁</p>;
      default:
        return null; // Default case, can be customized based on your requirements
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="flex gap-3 text-sm font-semibold">
        {/* 아이콘 */}
        <Link to="/">
          <img src={home} alt="logo" className="h-4" />
        </Link>
        <p>></p>
        <Link to="/company">
          <p>회사 소개</p>
        </Link>
        <p>></p>
        <p className="text-main">{renderTitle()}</p>
      </div>
      {/* 타이틀 */}
      <p className="text-5xl font-bold text-gray-900">{renderTitle()}</p>
      {/* 상세 */}
      <div>
        <div className="inline-flex items-center h-10 gap-1 px-1 bg-gray-100 rounded-full">
          <button
            onClick={() => handleTabChange("company")}
            className={`h-8 px-6  rounded-full ${
              selectedTab === "company" ? "bg-main text-white" : "text-gray-500"
            }`}
          >
            {" "}
            코끼리협동조합
          </button>
          {/* <button
            onClick={() => handleTabChange("company2")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "company2"
                ? "bg-main text-white"
                : "text-gray-500"
            }`}
          >
            {" "}
            팀 소개
          </button> */}
          <button
            onClick={() => handleTabChange("company3")}
            className={`h-8 px-6 rounded-full ${
              selectedTab === "company3"
                ? "bg-main text-white"
                : "text-gray-500"
            }`}
          >
            {" "}
            연혁
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompanyMap;
